export const pageTitle = (title) => {
  return (document.title = `${title} - Innovation for you`);
};
